import { isObject, pick } from "underscore";
import t from "../react/helpers/t";
import ChartDataAPIConfig from "./ChartDataAPIConfig";

/**
 * @description
 * Convert to C3 input
 * @param {Object} dataPreconf
 * @returns {(data: String) => Object}
 */
export const ChartDataMaker = (dataPreconf) => (data) => ({
  ...dataPreconf,
  json: data,
  keys: {
    ...dataPreconf.keys,
    value: data
      .map((x) => (isObject(x) ? Object.keys(x) : []))
      .reduce((a, b) => [...new Set(a.concat(b))], []),
  },
});

const PreloadChartDataMaker = ChartDataMaker(ChartDataAPIConfig);

/**
 * @description
 * Assuming data is an array, this function extract selected keyname and date
 * in each of array's element. The value object corresponding to keyname will
 * be flattened.
 * @version 220602
 * The object structure is based on data requested on June 02, 2022.
 * Additional modifications are required in case API changes.
 * @example
 * const aMapper = ChartDataMapper("a", "c");
 * const data = [
 *     { a: 1, b: 2, c: 2, date: "Jun 22" },
 *     { a: 3, b: 0, c: 5, date: "Jul 22" },
 * ];
 * aMapper(data);
 * // {
 * //     json: [{a: 1, c: 2, date: "Jun 22"}, {a: 3, c: 5, date: "Jul 22"}],
 * //     keys: { x: "date", value: ["a", "c"] },
 * // }
 * @param {String} keynames
 * @returns {(data: String) => Object}
 */
export const ChartDataMapper =
  (...keynames) =>
  (data) =>
    PreloadChartDataMaker(data.map((x) => pick(x, "date", ...keynames)));

export const TranslateAndReturnChartDataObjMapper = (keyname) => (data) => {
  let newData = data;
  data.forEach(function (val, index) {
    newData[index][keyname] = {};
    for (const [key, value] of Object.entries(val[keyname])) {
      newData[index][keyname][t(key)] = value;
    }
  });
  let result = PreloadChartDataMaker(newData.map(({ [keyname]: x, date }) => ({ date, ...x })));
  return result;
};
/**
 * @description
 * Assuming data is an array, this function extract selected keyname and date
 * in each of array's element. The value object corresponding to keyname will
 * be flattened.
 * @version 220602
 * The object structure is based on data requested on June 02, 2022.
 * Additional modifications are required in case API changes.
 * @example
 * const totalMapper = ChartDataObjMapper("total");
 * const data = [
 *     { total: { a: 1, b: 2 }, date: "Jun 22" },
 *     { total: { a: 3, b: 5 }, date: "Jul 22" },
 * ];
 * totalMapper(data);
 * // {
 * //     json: [{a: 1, b: 2, date: "Jun 22"}, {a: 3, b: 5, date: "Jul 22"}],
 * //     keys: { x: "date", value: ["a", "b"] },
 * // }
 * @param {String} keyname
 * @returns {(data: String) => Object}
 */
export const ChartDataObjMapper = (keyname) => (data) =>
  PreloadChartDataMaker(data.map(({ [keyname]: x, date }) => ({ date, ...x })));

export const filterGeneratorPieChart = (keyname) => (data) => {
  let json;
  let keys;
  if (keyname) {
    json = [data[keyname]];
    keys = {
      value: Object.keys(data[keyname]),
    };
  } else {
    json = [data];
    keys = {
      value: Object.keys(data),
    };
  }
  return { json, keys };
};
